import instance from "./instance";

import newsModule from "./news";
import votingsModule from "./votings";
import passesModule from "./passes";
import servicesModule from "./services";
import usersModule from "./users";
import homesModule from "./homes";
import supportModule from "./support";
import communalPaymentsModule from "./communalPayments";
import tariffsModule from "./tariffs";
import sharingModule from "./sharing";
import bookingModule from "./booking";
import employeesModule from "./employees";
import securityModule from "./security";
import notificationsModule from "./notifications";
import analyticsModule from "./analytics";
import marketModule from "./market";
import cafeModule from "./cafe";
import personalAccountsModule from "./personalAccounts";
import countersModule from "./counters";
import paidServicesModule from "./paid-services";

import requestsModule from "./requests";

export default {
  news: newsModule(instance),
  votings: votingsModule(instance),
  passes: passesModule(instance),
  services: servicesModule(instance),
  users: usersModule(instance),
  homes: homesModule(instance),
  support: supportModule(instance),
  communalPayments: communalPaymentsModule(instance),
  tariffs: tariffsModule(instance),
  sharing: sharingModule(instance),
  booking: bookingModule(instance),
  employees: employeesModule(instance),
  security: securityModule(instance),
  notifications: notificationsModule(instance),
  requests: requestsModule(instance),
  analytics: analyticsModule(instance),
  market: marketModule(instance),
  cafe: cafeModule(instance),
  personalAccounts: personalAccountsModule(instance),
  counters: countersModule(instance),
  paidServices: paidServicesModule(instance)
};
